import { type ComponentProps, type FC } from "react";
import { LazyLoadImage } from "@root/shared/components/LazyLoadImage";
import { MultiLineText } from "@root/shared/components/MultiLineText";
import * as styles from "./styles.css";

type Props = {
  heading: string;
  image?: ImageProps;
  body: string;
};

type ImageProps = ComponentProps<typeof LazyLoadImage>;

export const ClientOwnerContents: FC<Props> = ({ heading, image, body }) => (
  <section className="p-job-group-inner">
    <h3 className={styles.heading}>{heading}</h3>
    <div className={styles.container}>
      {image && (
        <div className={styles.ownerImage}>
          <LazyLoadImage
            src={image.src}
            dummyImgPath={image.dummyImgPath}
            alt={image.alt}
            width={image.width}
            height={image.height}
          />
        </div>
      )}
      <div className={`${styles.ownerMessage} js-toggle-text-area`}>
        <MultiLineText text={body} />
      </div>
    </div>
  </section>
);
